/**
 * This module provides a centralized way to access the Vue Router instance
 * across non-component files where Vue composables like useRouter() cannot be used.
 *
 * It solves circular dependency issues that arise when importing the router directly
 * in store modules and services. Instead of importing the router, files can get
 * the router instance through getRouter().
 *
 * Usage:
 * 1. Set router on app initialization:
 *    setGlobalRouter(router)
 *
 * 2. Access router anywhere:
 *    import { getRouter } from './global-router'
 *    getRouter().push('/path')
 */

let routerInstance = null;

export const setGlobalRouter = router => {
  routerInstance = router;
};

export const getRouter = () => {
  return routerInstance;
};
